// extracted by mini-css-extract-plugin
module.exports =  {"outletWrapper":"Root-module__outletWrapper--WJs9j"};